<h1 mat-dialog-title>{{ data.status === 'success' ? 'SMS Sent' : 'SMS Failed' }}</h1>

<div mat-dialog-content class="sms-result" [class.error]="data.status === 'error'">
    <mat-icon>{{ data.status === 'success' ? 'check_circle' : 'error' }}</mat-icon>
    <div>{{ data.message }}</div>
</div>

<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close>OK</button>
</div>
